export default "__VITE_PUBLIC_ASSET__f9710358__"